var compStoreLocator = (function () {
});
$(document).ready(function () {
    /* this will hide the back arrow button when into the home page */
    if (($('#homePage').length > 0 && $('.banner-tile').length > 0) || ($('#rewardsTracker').length > 0 && $('#rewards-history').length < 1)) {
        $('.navBack').removeClass('d-block').addClass('d-none');
    }

});
let continueWithoutDealClicked = false;
if ($('#locator')) {

    (function () {
        $(function () {
            subwayScript.showSpinner();
            var prDeliveryFlag = $("#prdeliveryTabActive").val();
            if ($("#isLocator").val() && $("#isLocator").val() != "en-US" && $("#isLocator").val() != "en-PR" && $("#isLocator").val() != "es-PR") {
                deliveryAkamai();
            }
            else {
                if (($("#isLocator").val() == "en-PR" || $("#isLocator").val() == "es-PR") && prDeliveryFlag == "true") {
                    deliveryAkamai();
                } else if (($("#isLocator").val() == "en-PR" || $("#isLocator").val() == "es-PR") && prDeliveryFlag == "false") {
                    $("#deliveryTabActive").val("false");
                }
                subwayScript.hideSpinner();
                initdeliveryLocatorCallback();
            }
            //if ($("#isLocator").val() && $("#isLocator").val() != "en-US") {
            //    deliveryAkamai();
            //}
            //else {
            //    subwayScript.hideSpinner();
            //    initdeliveryLocatorCallback();
            //}
        })
        //hiding sticky-header on locator/deliverylocatore page
        if (isCurrentPage('locator') || isCurrentPage('deliveryLocator')) {
            $(".body-top-margin").hide();
            $(".header-sticky").hide();
            $(".component_footer").hide();
            if ($(window).width() < 1024) {
                $('#subwayDeliveryLocator').find('#dellocbtn').removeClass('hide');
            }
        }
        if (isCurrentPage('locator')) {
            const existingStore = getCookieByCountry();
            var prodId = getLocatorUrlVars()["mProductId"];
            var catId = getLocatorUrlVars()["mCategoryId"];

            if (existingStore && !orderViewModel.hasLoggedIn) {

                if (prodId && catId) {
                    let storeID = existingStore.LocationId.StoreNumber;
                    let satNum = existingStore.LocationId.SatelliteNumber;
                    let storeCountry = existingStore.LocationId.Country;
                    let sitecoreCultureCode = $('#scLanguageCode').val();
                    let redirectUrl = window.location.origin + "/Stores/Redirect.aspx?s=" + storeID + "&sa=" + satNum + "&scc=" + storeCountry + "&mProductId=" + prodId + "&mCategoryId=" + catId + "&sitecoreCultureCode=" + sitecoreCultureCode;
                    window.location.href = redirectUrl;
                }

            }
        }
    })();
}


function deliveryAkamai() {
    $.ajax({
        url: $('#frmDeliveryAkamai').attr('action'),
        type: 'GET',
        headers: { "cache-control": "no-cache" },
        dataType: 'JSON',
        error: function (jqXhr) {
            $('#prod-loader').hide();
            initdeliveryLocatorCallback();
            subwayScript.showAjaxError(jqXhr);
        },
        success: function (resultData) {
            if (!resultData.Flag) {
                $("#deliveryTabActive").val("false");
            }
            else {
                $("#deliveryTabActive").val(resultData.Flag);
            }
            $('#prod-loader').hide();
            initdeliveryLocatorCallback();
        }
    });
}

function getLocatorUrlVars() {
    let vars = [], hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function initdeliveryLocatorCallback() {
    compStoreLocator.Init();
}




$(function () {

    /* Start order button hide for locator&deliverylocator */
    var pathLocName = window.location.pathname;
    if (pathLocName.indexOf('/locator') > -1 || pathLocName.indexOf('/deliverylocator') > -1) {
        $('.startorder-only-footer, .startorder-footer, #orderType').remove();
    }

    if (pathLocName.indexOf('/menu') > -1 && orderViewModel.currentOrder.cartQuantity == 0) {
        $('.startorder-only-footer').remove();
    }



    var storeId = window.orderViewModel.store.id;
    if (storeId !== null) {
        $('a[href*="Locator"]')
            .each(function () {
                $(this).attr('href', subwayScript.navigation.getMenuUrl(orderViewModel.store.id));
            });

        if ($('.locator-bar').length) {
            $(".locator-bar").attr('style', 'display:none');
        }
    }
    getOrderType();
});

var isUserLoggedIn = $('#isUserLoggedIn').val();
var orderTypeText = "";

function getOrderType() {
    if ($('.delivery-orderType-text').length && $('.delivery-text-link').length) {
        if (orderViewModel.orderType === "delivery") {
            orderTypeText = $('#deliveryToText').val();
            if ($(window).width() > 767) {
                $('.deliveryto-img').show();
            }
            $('.pickupfrom-img').hide();
            $('.delivery-text-link').html(orderViewModel.DeliveryAddress.StreetAddressLine1);
            $(document).on('click', '.delivery-text-link', function () {
                analytics.defaultStoreHeader();
                orderViewModel.maintainCartAddressClick = true;
                orderViewModel.save();
                window.location.href = subwayScript.navigation.getDeliveryLocatorUrl();
            });
        } else if ((!orderViewModel.orderType) && $('#transactionalHeader').find('.navbar-shadow').hasClass('display-mobile')) {
            $('#transactionalHeader').find('.navbar-shadow').removeClass('display-mobile').hide();
        }
        else {
            if (orderViewModel.orderType === "curbside") {
                orderTypeText = $('#curbsidepickupText').val();
                $('.deliveryto-img').hide();
                $('.pickupfrom-img').show();
            } else {
                orderTypeText = $('#pickupOnlyText').val();
            }
            $('.delivery-text-link').html(orderViewModel.store.address1);
            $(document).on('click', '.delivery-text-link', function () {
                analytics.defaultStoreHeader();
                orderViewModel.maintainCartAddressClick = true;
                orderViewModel.save();
                window.location.href = subwayScript.navigation.getLocatorUrl();
            });
        }
        $('.delivery-orderType-text').html(orderTypeText);
    }
}

var tempSelectedStoreData;

var locatorConfig = {
    getApiLocatorUrl: function () {
        return window.LocatorLoader;
    },
    getApiUser: function () {
        return window.LocatorVendorId;
    },
    getApiKey: function () {
        return window.LocatorVendorKey;
    },
    getCulture: function () {
        return $('html').attr('lang');
    },
    getInitialFilters: function () {
        return window.LocatorInitialFilters;
    },
    getVendorTemplate: function () {
        return 'order2modal';
    },
    getMyMapsKey: function () {
        return window.SubwayPickUpLocatorGoogleAPIKey;
    }
};
compStoreLocator.Init = function (enableSelectionButton, dataNew) {
    if (dataNew && Object.keys(dataNew).length > 0) {
        const apiUrl = "/api/sitecore/Restaurant/CreateNewCart"
        createCart(dataNew, apiUrl, true)
    }
    if ($('[data-component="locator"]').length) {

        var tempStoreData = null;
        var bodyLoaded = document.body;
        var currentOrderType = orderViewModel.orderType;

        var trackingUrl = '/dist/RemoteOrder/js/locator-tracking.js';

        var locatorScript = document.createElement('script');
        locatorScript.type = 'text/javascript';
        locatorScript.src = locatorConfig.getApiLocatorUrl();

        var trackingScript = document.createElement('script');
        trackingScript.type = 'text/javascript';
        trackingScript.src = trackingUrl;

        trackingScript.onload = function () {
            bodyLoaded.appendChild(locatorScript);
        }
        const params = window.location.search;
        var pageFilter;
        if (params != null && params != undefined && params.toLowerCase().includes('cat=1')) {
            pageFilter = 'HasCatering';
        }
        else {
            pageFilter = locatorConfig.getInitialFilters();
        }

        locatorScript.onload = function () {
            var validateOfferUrl = $('#frmValidateOffer').attr('action');
            const curbsideFlag = client.variation(
                FF_FULFILLMENT_TYPE_CURBSIDE,
                true
            );

            var locatorOptions = {
                disabledFeatures: curbsideFlag ? [] : ['curbside'],
                enableSelection: enableSelectionButton != undefined && enableSelectionButton ? true : false,
                autoGps: orderViewModel.store.StoreId ? false : true,
                container: 'subwayLocator',
                culture: locatorConfig.getCulture(),
                apiUser: locatorConfig.getApiUser(),
                apiKey: locatorConfig.getApiKey(),
                mapsKey: locatorConfig.getMyMapsKey(),
                initialFilters: pageFilter,
                vendorTemplate: locatorConfig.getVendorTemplate(),
                searchesHistory: 5,
                disableOrderMode: ($("#isNonTransactional").val() === "true") || false,
                externalEvents: {
                    onLocatorReady: locatorReady,
                    onResultSelect: locatorResultSelect,
                    //onOrderOnline: trackOrderOnline,  This would need to be implemented in the orderOnline function
                    onOrderOnline: orderOnline,
                    onCatering: trackCatering,
                    onNavigationStart: trackDirections,
                    //onSearchStart: trackSearch, //trackSearch is implemeted on onBeforeSearch in locatorTextSearch
                    onBeforeSearch: locatorTextSearch,
                    onSearchSuccess: locatorSearchSuccess,
                    onGpsStart: locatorGpsSearch,
                    onGpsEnd: locatorGpsSearchEnd,
                    onDeliveryNavClick: navigateToDelivryLocatorPage,
                    onPageChange: onPageChangeFunction,
                    onStoreDetails: onStoreDetailsFunction,
                    onPhoneCall: onPhoneCallFunction,
                    onLocatorClose: onLocatorCloseFunction,
                    onExplicitNoneSelected: continueWithoutDeal
                }
            }

            var locationDetails = {};

            if (isUserLoggedIn == 'value') {
                GetLastOneOrder(locationDetails);
            }
            var locator = new window.FwhLocator();
            locator.init(locatorOptions);
            if (getParameterByName('promoId') || getParameterByName('offer')) {
                let promos = []
                const offerParams = getParameterByName('offer');
                const objOffers = offerParams && JSON.parse(offerParams);
                if (getParameterByName('promoId')) {
                    getParameterByName('isCart') ? promos.push("PLU" + getParameterByName('promoId')) : promos.push(getParameterByName('promoId'))
                } else if (getParameterByName('offer')) {
                    promos.push("PLU" + objOffers.offerId)
                }
                const promoConfig = {
                    "range": 50,
                    "promos": promos
                }
                locator.setPromoFilter(promoConfig);
            }
            if (isUserLoggedIn == 'value' && locationDetails.locationId != undefined) {
                locator.addRecentStore(locationDetails.locationId, locationDetails.satelliteId);
            }
            if (orderViewModel.store.storeNumber) {
                locator.addRecentlyBrowsedStore(orderViewModel.store.storeNumber, orderViewModel.store.satelliteNumber);
            }
            $(window).on("load", function () {
                $('.menu-Header').html(orderViewModel.pageLabel);
            });
            function navigateToDelivryLocatorPage() {
                engageApptentiveEvent('deliveryTabBtn')
                var buttonText = $('.deliverySelectButton').text().trim();
                var offerParams = getParameterByName('offer');
                var productId = getParameterByName('mProductId');
                var categoryId = getParameterByName('mCategoryId');
                var menuSlider = "?mProductId=" + productId + "&" + "mCategoryId=" + categoryId;
                var promotionPLUId = getParameterByName('promoId');
                var promoCodeData = getParameterByName('promoCode');
                analytics.locatorClick(buttonText);
                var offerdata = "";
                var promotionID = "";
                var promoCodeId = "";
                var maintainCartUrl = "?" + subwayScript.IsEdit + "=true";
                if (promotionPLUId)
                    promotionID = "?promoId=" + promotionPLUId;
                if (promoCodeData)
                    promoCodeId = "&promoCode=" + promoCodeData;
                if (offerParams)
                    offerdata = "?offer=" + offerParams;
                if (orderViewModel.maintainCartAddressClick) {
                    window.location.href = subwayScript.navigation.getDeliveryLocatorUrl();
                }
                else if (window.location.href.toLowerCase().indexOf(subwayScript.IsEdit) > 1) {
                    window.location.href = subwayScript.navigation.getDeliveryLocatorUrl() + maintainCartUrl;
                }
                else if (orderViewModel.currentOrder.cartQuantity) {
                    orderViewModel.orderNowDashboardClick = true;
                    orderViewModel.save();
                    window.location.href = subwayScript.navigation.getDeliveryLocatorUrl();
                }
                else if (productId && categoryId) {
                    window.location.href = subwayScript.navigation.getDeliveryLocatorUrl() + menuSlider;
                }
                else {
                    orderViewModel.flushCart();
                    if (ShopPromotionFlag == 'true') {
                        window.location.href = subwayScript.navigation.getDeliveryLocatorUrl() + offerdata + promotionID + promoCodeId;
                    } else {
                        window.location.href = subwayScript.navigation.getDeliveryLocatorUrl() + offerdata;

                    }
                }
            }
            function locatorReady() {
                subwayScript.hideSpinner();
                var hasGpsSearch = (typeof (localStorage.locationGpsExecute) !== 'undefined' && localStorage.locationGpsExecute === 'true')
                var hasTextSearch = (typeof (localStorage.locationSearchText) !== 'undefined' && localStorage.locationSearchText.trim().length > 0);

                $('.previousSearchesContent').on('click', 'button', function () {
                    var recentTxt = $('.previousSearchesTitle').text();
                    analytics.recentOrderClickPickUp(recentTxt);
                });

                if (orderViewModel.store.StoreId) {
                    locator.startExternalSearch(orderViewModel.store.address + ", " + orderViewModel.store.city + (orderViewModel.store.stateProvCode.length > 0 ? " " + orderViewModel.store.stateProvCode : "") + ", " + orderViewModel.store.storeCountry);
                }
                launchdarkly.HideFullfillmentTypeDelivery();
                if (!hasGpsSearch && !hasTextSearch) {
                    return;
                }

                if (hasGpsSearch) {
                    $('button.locator-gps').trigger('click');
                } else if (hasTextSearch) {
                    $('.searchLocationInput').val(localStorage.locationSearchText);
                    $('button.btnDoSearch').trigger('click');
                }

                localStorage.setItem('locationSearchText', '');
                localStorage.setItem('locationGpsExecute', '');
            }

            function locatorTextSearch(searchInfo) {

                var buttonText = "";

                switch (searchInfo.source) {

                    case "autocomplete":
                        buttonText = "predictive store search";
                        if (searchInfo.data.length > 0) {
                            trackSearchResult(searchInfo.data);
                        }
                        break;

                    case "apply":
                        buttonText = $('.btnApplyAll').text().trim();
                        trackSearchResult(searchInfo.data);
                        break;

                    case "gps":
                        trackSearchResult('geo search');
                        if (searchInfo.data.length > 0) {
                            trackSearchResult(searchInfo.data);
                        }
                        break;

                    case "search":
                        if (searchInfo.data.length > 0) {
                            buttonText = "store search";
                            trackSearchResult(searchInfo.data);
                        }
                        break;

                    default:
                        break;
                }

                if (searchInfo.data) {
                    analytics.locatorTextClick(buttonText, searchInfo.data, false);
                }

                return true;

            }
            let lastSearchLocation;
            function locatorSearchSuccess(searchInfo) {
                lastSearchLocation = searchInfo;
                var checkVal = searchInfo.split(',')

                var isMap = checkVal.length == 2 && Number(checkVal[0]) && Number(checkVal[1]);
                if (isMap) {
                    return analytics.locatorTextClick('', '', true);
                }
                return false;
            }

            function locatorGpsSearchEnd(data) {
                analytics.locatorClick("predictive search");
            }
            function locatorGpsSearch() { }
            function onPageChangeFunction(data) {
                var buttonText;
                if (data.currentPage > data.nextPage) {
                    buttonText = $('.pagingButton:first').text().trim();
                }
                else {
                    buttonText = $('.pagingButton:last').text().trim();
                }
                analytics.locatorPrevNextClick(buttonText);
            }
            function onStoreDetailsFunction(data) {
                if (data.action == 'show') {
                    engageApptentiveEvent('restaurant_details')
                }
                analytics.storeDetailsAnalytics();
            }
            function onPhoneCallFunction(storeData) {
                var buttonText = $("[data-id='" + storeData.LocationId.StoreNumber + "-" + storeData.LocationId.SatelliteNumber + "']").find('.locatorPhoneButton').text().trim();
                analytics.locatorClick(buttonText);
            }

            function orderOnline(storeData, source) {
                try {
                    let buttonText;
                    const isNonTransactional = $("#isNonTransactional").val() === "true" ? true : false
                    if (isNonTransactional) {
                        analytics.orderType("In-Store Pickup", "DOWNLOAD THE APP TO ORDER");
                        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                        analytics.downloadAppCall();
                        window.location.href = isSafari ? $('#ios').val() : $('#android').val()
                        return false;
                    }
                    if (source == "store") {
                        engageApptentiveEvent('inStore')
                        orderViewModel.AnalyticsorderType = "In-Store Pickup";
                        orderViewModel.Analytics.restaurantSelected = 1;
                        orderViewModel.Analytics.pickup = 1;
                        orderViewModel.save();
                        buttonText = "order here"
                    }

                    analytics.orderType(orderViewModel.AnalyticsorderType, buttonText);
                    analytics.locatorClick(buttonText);

                    subwayScript.showSpinner();
                    setTimeout(function () {
                        resultSelected(storeData, source);
                    }, 100);
                }
                catch (err) {
                    void 0;
                }
                return false;
            }
            function continueWithoutDeal() {
                locator.setPromoFilter(null);
                continueWithoutDealClicked = true
                locator.startExternalSearch(lastSearchLocation);
            }
            function locatorResultSelect(storeData) {
                subwayScript.showSpinner();
                setTimeout(function () {
                    updateFavStore(storeData);
                }, 100);
                return false;
            }

            function resultSelected(storeData, source) {
                tempSelectedStoreData = storeData;
                orderViewModel.storeData = storeData;
                if (source == "curb") {
                    source = "curbside"
                }
                if (source == "store") {
                    source = "pickup"
                }
                orderViewModel.previousOrdertype = orderViewModel.orderType;
                orderViewModel.orderType = source;
                orderViewModel.save();
                //offers param getting from cpc
                var offerParams = getParameterByName('offer');
                var objOffers = JSON.parse(offerParams);
                var objOfferViewmodel = orderViewModel.selectedOffer;


                if (ShopPromotionFlag !== 'true' && (objOffers || objOfferViewmodel)) {
                    var propositionGuid = (objOffers && objOffers.propositionGuid) ? objOffers.propositionGuid : objOfferViewmodel.OfferUri;
                    var voucherQueryModel = {
                        "Offers": [
                            {
                                "propositionGuid": propositionGuid
                            }
                        ],
                        "storeId": storeData.LocationId.StoreNumber + "-" + storeData.LocationId.SatelliteNumber,
                        "country": storeData.Address.CountryCode
                    }
                    // validate voucher code then apply offer
                    loyaltyObject.validateVoucherAndApplyOffer(voucherQueryModel, validateOfferUrl).then(applyOffer);
                }
                else if (orderViewModel.maintainCartAddressClick || window.location.href.toLowerCase().indexOf(subwayScript.IsEdit) > 1 || orderViewModel.currentOrder.cartQuantity) {
                    if (ShopPromotionFlag == "true" && !continueWithoutDealClicked && (getParameterByName('offer') || getParameterByName('promoCode'))) {
                        applyPromoToCartAPICall({}, currentOrderType)
                        return;
                    } else {
                        navigateToCheckout(currentOrderType)

                    }

                }
                else {
                    applyOffer();
                }


            }
        };

        bodyLoaded.appendChild(trackingScript);
    }
    function GetLastOneOrder(locationDetails) {
        var orderHistoryId = $("#initStoreId").val();
        var dataSourceId = $("#DataSourceId").val();
        var postURL = "/RemoteOrder/Orders/GetLastOrderAsync";
        $.ajax({
            url: postURL,
            type: 'POST',
            data: { "storeId": orderHistoryId, "dataSourceId": dataSourceId, "SiteName": $('#hdnSiteName').val() },
            async: false,
            success: function (data) {
                if (data != null) {
                    var Id = data.Location.LocationId;
                    var splittedLocationId = Id.split("-");
                    locationDetails.locationId = parseInt(splittedLocationId[0]);
                    locationDetails.satelliteId = parseInt(splittedLocationId[1]);
                }
                if (isCurrentPage('locator')) {
                    const existingStore = getCookie('userStoreData');
                    let prodId = getLocatorUrlVars()["mProductId"];
                    let catId = getLocatorUrlVars()["mCategoryId"];

                    if (orderViewModel.hasLoggedIn) {
                        if (prodId && catId) {
                            let storeID = data.Location.LocationId;
                            let satNum = data.Location.LocationId.split('-')[1];
                            let storeCountry = data.Location.Address.Country;
                            let sitecoreCultureCode = $('#scLanguageCode').val();
                            let redirectUrl = window.location.origin + "/Stores/Redirect.aspx?s=" + storeID + "&sa=" + satNum + "&scc=" + storeCountry + "&mProductId=" + prodId + "&mCategoryId=" + catId + "&sitecoreCultureCode=" + sitecoreCultureCode;
                            window.location.href = redirectUrl;
                        }

                    }

                }
            }

        });

    }
    function applyOffer() {
        var storeData = tempSelectedStoreData;
        var createCartEndpoint = $('#frmCreateCart').attr('action');
        let isCreateCartSuccess = {};
        let selectedStoreId = orderViewModel.storeData.LocationId.StoreNumber + "-" + orderViewModel.storeData.LocationId.SatelliteNumber;
        if (!orderViewModel.currentOrder.cartId || selectedStoreId !== orderViewModel.store.id || orderViewModel.orderType.toLowerCase() == "curbside") {

            isCreateCartSuccess = createCart(storeData, createCartEndpoint);
        } else if (ShopPromotionFlag == "true" && !continueWithoutDealClicked && (getParameterByName('offer') || getParameterByName('promoCode'))) {
            applyPromoToCartAPICall(isCreateCartSuccess)
            return;
        }
        var checkAvailableUrl = $('#frmAvailableOffer').attr('action');
        if (isCreateCartSuccess.result) {
            if (orderViewModel.selectedOffer && orderViewModel.selectedOffer.offerId) {
                $.ajax({
                    url: checkAvailableUrl,
                    type: 'POST',
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify({
                        "cartId": orderViewModel.currentOrder.cartId,
                        "storeId": storeData.LocationId.StoreNumber + "-" + storeData.LocationId.SatelliteNumber,
                        "SiteName": $('#hdnSiteName').val(),
                        "Offers": [{
                            "OfferId": orderViewModel.selectedOffer.offerId,
                            "OfferUri": orderViewModel.selectedOffer.propositionGuid,
                            "OfferCampaignUri": orderViewModel.selectedOffer.offerCampaignUri,
                            "RewardType": orderViewModel.selectedOffer.offerType,
                            "OfferDescription": orderViewModel.selectedOffer.offerDescription,
                            "RewardExpirationDate": orderViewModel.selectedOffer.rewardExpirationDate != null ? orderViewModel.selectedOffer.rewardExpirationDate : orderViewModel.selectedOffer.expirationDate
                        }]
                    }),
                    success: function (data) {
                        if (data.NotOffered) {
                            tempStoreData = storeData;
                            modalShowId('#modal-find-new-location');
                            const errMsg = $('#modal-find-new-location .fav-modal-title').text() || ''
                            analytics.errorMessage(errMsg)
                        } else {
                            orderViewModel.selectedOffer.confirmedValid = true;
                            orderViewModel.currentOrder.cartId = data.Results.CartId;
                            orderViewModel.save();
                            storeSelected(storeData);
                            subwayScript.setCookie('CartId', orderViewModel.currentOrder.cartId, 90);
                        }

                    },
                    error: function (jqXhr) {
                        subwayScript.showAjaxError(jqXhr);

                    }
                });
            } else {
                storeSelected(storeData);
            }
        }
        else if (!$.isEmptyObject(isCreateCartSuccess)) {
            if (isCreateCartSuccess.Error || !isCreateCartSuccess.IsWebOrderAvailable || !isCreateCartSuccess.IsStoreOpen || !isCreateCartSuccess.result)
                return false;
        }
        else {
            window.location.href = getUrl();

        }

    }

    function storeSelected(storeData) {
        var isoLookupEndpoint = $('#frmLanguageCode').attr('action');
        var siteName = $('#hdnSiteName').val();
        subwayScript.showSpinner();
        $.ajax({
            url: isoLookupEndpoint,
            type: 'GET',
            data: { restaurantid: subwayScript.getStoreId(storeData.LocationId.StoreNumber, storeData.LocationId.SatelliteNumber), siteName: siteName },
            error: function () {
                orderViewModel.store.languageCode = analytics.fallbackLanguage;
                orderViewModel.save();
            },
            success: function (data) {
                if (data.IsStoreOpen) {
                    $('#scLanguageCode').val(data.AvailableStoreCultures);
                }
                orderViewModel.store.languageCode = data.LanguageCode;
                orderViewModel.save();
            },
            complete: function () {
                updateStore(storeData);
            }
        });
    }

    function updateStore(data) {
        var createCartEndpoint = $('#frmCreateCart').attr('action');
        let categoryId = getParameterByName("mCategoryId");
        let productId = getParameterByName("mProductId");

        if (orderViewModel.currentOrder.cartId) {
            $.ajax({
                url: $('#frmUpdateStore').attr('action'),
                type: 'POST',
                cache: false,
                dataType: 'json',
                async: false,
                contentType: "application/json; charset=utf-8",
                headers: { "cache-control": "no-cache" },
                data: JSON.stringify({
                    storeId: subwayScript.getStoreId(data.LocationId.StoreNumber, data.LocationId.SatelliteNumber),
                    cartId: orderViewModel.currentOrder.cartId,
                    siteName: $('#hdnSiteName').val(),
                    CategoryId: getQueryParamsId("mcategoryid")

                }),
                error: function (jqXhr) {
                    subwayScript.showAjaxError(jqXhr);
                },
                success: function (resultData) {
                    eraseCookie("CurbSideToggle");
                    if (resultData.Error) {
                        subwayScript.showAjaxError(resultData);
                    } else if (!resultData.IsWebOrderAvailable) {
                        modalShowId('#modal-web-order-not-available');
                        const errMsg = $('#modal-web-order-not-available .error-body').text() || ''
                        analytics.errorMessage(errMsg)
                    } else if (!resultData.IsStoreOpen) {
                        modalShowId('#modal-store-closed');
                        globalUtil.modalPopupOpen('#modal-store-closed');
                        const errMsg = $('#modal-store-closed .body-txt').text() || '';
                        analytics.errorMessage(errMsg)
                    } else {
                        $('#scLanguageCode').val(resultData.AvailableStoreCultures);
                        updateStoreDetails(data, resultData.Store);
                        if (categoryId && productId) {
                            let s = data.LocationId.StoreNumber;
                            let sa = data.LocationId.SatelliteNumber;
                            let scc = data.Address.CountryCode;
                            let sitecoreCultureCode = $('#scLanguageCode').val();
                            //storeSelected(data);
                            let redirectUrl = window.location.origin + "/Stores/Redirect.aspx?s=" + s + "&sa=" + sa + "&scc=" + scc + "&mProductId=" + productId + "&mCategoryId=" + categoryId + "&sitecoreCultureCode=" + sitecoreCultureCode;
                            window.location.href = resultData.CategoryRedirectionUrl ? resultData.CategoryRedirectionUrl : redirectUrl;
                        }
                        else if (orderViewModel.IsRecentOrder || orderViewModel.IsRecentOrderAddToCart) {
                            orderViewModel.IsRecentOrder = false;
                            orderViewModel.store.StoreId = formatedStoreID(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                            orderViewModel.IsRecentOrderAddToCart = false;
                            orderViewModel.save();
                            window.location.href = subwayScript.navigation.getOrderHistoryUrl();
                        } else if (orderViewModel.IsOrderAgainAddToCart) {
                            orderViewModel.IsOrderAgainAddToCart = false;
                            orderViewModel.addToBagPayLoadItem = null;
                            orderViewModel.store.StoreId = formatedStoreID(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber);
                            orderViewModel.save();
                            window.location.href = subwayScript.navigation.getStoreMenu();
                        } else if (orderViewModel.isFavoriteOrder) {
                            orderViewModel.isFavoriteOrder = false;
                            orderViewModel.save();
                            window.location.href = subwayScript.navigation.getMyFavoritesUrl();
                        }
                        else if (categoryId && productId) {
                            return false;
                        }
                        else if (resultData.CategoryRedirectionUrl) {
                            window.location.href = resultData.CategoryRedirectionUrl;
                        }
                        else {
                            window.location.href = getUrl();
                        }
                    }
                }
            });
        } else {
            createCart(data, createCartEndpoint);
        }
        subwayScript.setCookie('CartId', orderViewModel.currentOrder.cartId, 90);
    }

    function formatedStoreID(storeID = '', satelliteId = '0') {
        let formatedStoreID = "";
        if (storeID) {
            formatedStoreID = `${storeID.toString().split('-')[0]}-${satelliteId}`;
        }

        return formatedStoreID;
    }

    function createCart(data, createCartEndpoint, isExistingVal) {
        var offerParams = getParameterByName('offer');
        var objOffers = offerParams && JSON.parse(offerParams);
        const promocode = getParameterByName('promoCode')
        let countryCode = "";
        countryCode = data.LocationId && data.LocationId.Country ? data.LocationId.Country : data.Address && data.Address.CountryCode;
        let createCartData = {
            StoreId: subwayScript.getStoreId(data.LocationId.StoreNumber, data.LocationId.SatelliteNumber),
            Country: countryCode,
            OrderType: data.orderType ? data.orderType : orderViewModel.orderType,
            SiteName: $('#hdnSiteName').val(),
            IsPromoID: ShopPromotionFlag == 'true' && !continueWithoutDealClicked ? getParameterByName('promoId') ? true : false : false,
            IsPromoCode: ShopPromotionFlag == 'true' && !continueWithoutDealClicked ? promocode ? true : false : false,
            IsDeal: ShopPromotionFlag == 'true' && !continueWithoutDealClicked ? offerParams ? true : false : false,
            Offers: [
                {
                    PromoCode: promocode,
                    PropositionGuid: objOffers && objOffers.propositionGuid,

                }
            ],
        };
        let returnResponse = {};

        $.ajax({
            url: createCartEndpoint,
            type: 'POST',
            cache: false,
            async: false,
            headers: { "cache-control": "no-cache" },
            data: createCartData,
            error: function (jqXhr) {
                returnResponse.result = false;
                if (jqXhr.responseJSON && (jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'dord-3006' || jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'ordr-3000')) {
                    modalShowId('#modal-store-closed');
                    globalUtil.modalPopupOpen('#modal-store-closed');
                }
                else {
                    subwayScript.showAjaxError(jqXhr);
                }
            },
            success: function (resultData) {
                returnResponse = resultData;
                orderViewModel.storeStatus = resultData.IsStoreOpen;
                orderViewModel.calledCreateCart = true;
                orderViewModel.save();
                if (window.FwhLocator) {
                    var locator = new window.FwhLocator();
                }
                if (resultData.Error) {
                    returnResponse.result = false;
                    subwayScript.showAjaxError(resultData);
                    if (locator) {
                        locator.asyncCallbackComplete();
                    }
                } else if (!resultData.IsWebOrderAvailable) {
                    returnResponse.result = false;
                    if (!isExistingVal) {
                        modalShowId('#modal-web-order-not-available');
                        const errMsg = $('#modal-web-order-not-available .error-body').text() || ''
                        analytics.errorMessage(errMsg);
                        if (locator) {
                            locator.asyncCallbackComplete();
                        }
                    }

                } else if (!resultData.IsStoreOpen) {
                    returnResponse.result = false;
                    // IsStoreOpen is false, may be stores where local POS is offline or is unsupportive of checkout.
                    if (!isExistingVal) {
                        modalShowId('#modal-store-closed');
                        globalUtil.modalPopupOpen('#modal-store-closed');
                        const errMsg = $('#modal-store-closed .body-txt').text() || '';
                        analytics.errorMessage(errMsg);
                        if (locator) {
                            locator.asyncCallbackComplete();
                        }
                    }

                } else {
                    if (isCurrentPage('locator')) {
                        setUserStoreCookie(data);
                    }
                    !isExistingVal && $('body').hasClass('isLoggedOut');
                    $('#scLanguageCode').val(resultData.AvailableStoreCultures);
                    orderViewModel.flushCart();
                    updateStoreDetails(data, resultData.Store);
                    orderViewModel.currentOrder.cartId = resultData.Cart.CartId;
                    orderViewModel.hasCurbside = resultData.HasCurbside;
                    orderViewModel.hasCurbsideBeforeHours = resultData.HasCurbsideBeforeHours;
                    orderViewModel.curbsideAvailableMessage = resultData.CurbsideAvailableMessage;
                    orderViewModel.cartOpen = true;

                    if (resultData.IsDealApplied) {
                        orderViewModel.showRedirectSuccessBanner = true
                        orderViewModel.redirectBannerMessage = Congrats;
                        orderViewModel.promosAndDeals.isPromoCodeApplied = getParameterByName('promoId') ? true : orderViewModel.promosAndDeals.isPromoCodeApplied

                    }
                    orderViewModel.save();
                    defaultStoreHeader();
                    if (orderViewModel.orderType === "pickup" || (resultData.HasCurbside === true && orderViewModel.orderType === "curbside")) {
                        returnResponse.result = true;
                    }
                    else if (resultData.HasCurbside === false && orderViewModel.orderType === "curbside") {
                        modalShowId('#curbside-error-popup');
                        const errMsg = $('#curbside-error-popup #error-body').text() || ''
                        analytics.errorMessage(errMsg)
                        returnResponse.result = false;
                    }
                }
            }
        });
        return returnResponse;
    }

    function updateStoreDetails(locatorStoreData, mvcStoreDetails) {
        orderViewModel.store.storeNumber = locatorStoreData.LocationId.StoreNumber;
        orderViewModel.store.satelliteNumber = locatorStoreData.LocationId.SatelliteNumber;
        mvcStoreDetails.StoreId = subwayScript.getStoreId(locatorStoreData.LocationId.StoreNumber, locatorStoreData.LocationId.SatelliteNumber);
        subwayScript.updateStoreDetails(mvcStoreDetails);
    }

    function moveOn() {
        storeSelected(tempStoreData);
    }



    function updateFavStore(data) {
        var updateFavStorEndpoint = $('#frmUpdateFavStore').attr('action');
        $.ajax({
            url: updateFavStorEndpoint,
            type: 'POST',
            data: {
                storeId: subwayScript.getStoreId(data.LocationId.StoreNumber, data.LocationId.SatelliteNumber)
            },
            error: function (jqXhr) {
                subwayScript.hideSpinner();
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (resultData) {
                orderViewModel.favStore.storeNumber = data.LocationId.StoreNumber;
                orderViewModel.favStore.satelliteNumber = data.LocationId.SatelliteNumber;
                orderViewModel.favStore.id = subwayScript.getStoreId(data.LocationId.StoreNumber, data.LocationId.SatelliteNumber);
                subwayScript.updateFavStore(data);
                var address3 = orderViewModel.favStore.address3 ? ', ' + orderViewModel.favStore.address3 : '';
                $('.dash-fav-location, .my-fav-location').html(orderViewModel.favStore.address1 + address3);
                $('.change-favorite-location, .change-text').show();
                subwayScript.hideSpinner();
                modalClose(true);
            }

        });
    }
    $('.delivery-locator').on('click', function () {
        var buttonText = $(this).text();
        analytics.orderType(buttonText);
        orderViewModel.Analytics.orderType = buttonText;
        orderViewModel.save();
        var deliveryUrl = subwayScript.navigation.getDeliveryLocatorUrl();
        window.location.href = deliveryUrl;
    });

    $('.continue-with-order').click(function () {
        analytics.invalidOffers(this.textContent, orderViewModel.selectedOffer.offerType, orderViewModel.selectedOffer.offerDescription);
        moveOn();
        orderViewModel.selectedOffer = null;
        return true;
    });

    $('.find-new-location').click(function () {
        orderViewModel.flushCart();
        analytics.invalidOffers(this.textContent, orderViewModel.selectedOffer.offerType, orderViewModel.selectedOffer.offerDescription);
        modalClose(true);
        return true;
    });
};



function applyPromoToCartAPICall(isCreateCartSuccess, currentOrderType) {
    var offerParams = getParameterByName('offer');
    var objOffers = offerParams && JSON.parse(offerParams);
    const promocode = getParameterByName('promoCode');
    var currentLocationId = orderViewModel.storeData ? subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber) : null;
    let payload = {
        StoreId: currentLocationId,
        SiteName: $('#hdnSiteName').val(),
        CartId: orderViewModel.currentOrder.cartId,
        IsPromoID: getParameterByName('promoId') ? true : false,
        IsPromoCode: promocode ? true : false,
        IsDeal: offerParams ? true : false,
        Country: orderViewModel.storeData.Address.CountryCode,
        Offers: [
            {
                PromoCode: promocode,
                PropositionGuid: objOffers && objOffers.propositionGuid,
            }
        ],
    };
    $.ajax({
        url: '/api/sitecore/Restaurant/ApplyPromoDeal',
        type: 'POST',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(payload),
        success: function (data) {
            if (data.IsDealApplied) {
                orderViewModel.showRedirectSuccessBanner = true
                orderViewModel.redirectBannerMessage = Congrats;
                orderViewModel.promosAndDeals.isPromoCodeApplied = getParameterByName('promoId') ? true : orderViewModel.promosAndDeals.isPromoCodeApplied
                orderViewModel.save();
            }

            if (orderViewModel.maintainCartAddressClick || window.location.href.toLowerCase().indexOf(subwayScript.IsEdit) > 1 || orderViewModel.currentOrder.cartQuantity) {
                navigateToCheckout(currentOrderType)
                return;
            }

            if (isCreateCartSuccess.result) {
                storeSelected(storeData);
            }
            else if (!$.isEmptyObject(isCreateCartSuccess)) {
                if (isCreateCartSuccess.Error || !isCreateCartSuccess.IsWebOrderAvailable || !isCreateCartSuccess.IsStoreOpen || !isCreateCartSuccess.result)
                    return false;
            }
            else {
                window.location.href = getUrl();
            }
        },
        error: function (jqXhr) {
            subwayScript.showAjaxError(jqXhr);

        }
    });
}

function getUrl() {
    var directUrl = getParameterByName('redirectURL');
    const storeId = orderViewModel.store.id || orderViewModel.store.StoreId
    if (directUrl == null || directUrl === "")
        return subwayScript.navigation.getMenuUrl(storeId);

    if (directUrl.indexOf("{{storeid}}") > -1) {
        directUrl = directUrl.replace("{{storeid}}", storeId);
    }
    var curContext = '/' + locatorConfig.getCulture();
    var newContext = '/' + $('#scLanguageCode').val();

    //Check if the directUrl doesn't already have the Sitecore context
    if (directUrl.indexOf(curContext) < 0) {
        return newContext + directUrl;
    }

    return directUrl.replace(curContext, newContext);

}

function navigateToCheckout(currentOrderType) {
    if (orderViewModel.store.StoreId === subwayScript.getStoreId(orderViewModel.storeData.LocationId.StoreNumber, orderViewModel.storeData.LocationId.SatelliteNumber) && currentOrderType === orderViewModel.orderType && orderViewModel.currentOrder.cartQuantity > 0) {
        navigateToOrderManagement();
    } else {
        updateMaintainCart();
    }
}

function navigateToOrderManagement() {
    window.location.href = subwayScript.navigation.getOrderManagementUrl();
}

function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 60 * 60 * 1000); //date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";

}

function readCookie(name) {
    var nameEq = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}
